import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: '/api/user/' }),
    tagTypes: ['info'],
    reducerPath: 'UserApi',
    endpoints: (builder) => ({
        registerBefore: builder.mutation({
            query: (args) => {
                return {
                    url: 'registerBefore',
                    method: 'POST',
                    body: args,
                };
            }
        }),
        registerBeforeCodeEnter: builder.mutation({
            query: (args) => {
                return {
                    url: 'registerBeforeCodeEnter',
                    method: 'POST',
                    body: args,
                };
            }
        }),
        register: builder.mutation({
            query: (args) => {
                return {
                    url: 'register',
                    method: 'POST',
                    body: args,
                };
            }
        }),
        authVk: builder.mutation({
            query: (args) => {
                return {
                    url: 'authVk',
                    method: 'POST',
                    body: args,
                };
            }
        }),
        authYa: builder.mutation({
            query: (args) => {
                return {
                    url: 'authYa',
                    method: 'POST',
                    body: args,
                };
            }
        }),
        authBindVk: builder.mutation({
            query: (args) => {
                return {
                    url: 'authBindVk',
                    method: 'POST',
                    body: args,
                };
            }
        }),
        authBindYa: builder.mutation({
            query: (args) => {
                return {
                    url: 'authBindYa',
                    method: 'POST',
                    body: args,
                };
            }
        }),
        /* authPkceGenerate: builder.mutation({
             query: (args) => {
                 return {
                     url: 'authPkceGenerate',
                     method: 'POST',
                     body: args,
                 };
             }
         }),
 
 
         login: builder.mutation({
             query: (args) => {
                 return {
                     url: 'login',
                     method: 'POST',
                     body: args,
                 };
             }
         }),*/
        infoGet: builder.query({
            query: (args) => {
                return {
                    url: 'infoGet',
                    method: 'GET',
                    params: args,
                };
            },
        }),
    }),
});

export const { useRegisterBeforeMutation, useRegisterBeforeCodeEnterMutation, useRegisterMutation,
    useAuthVkMutation, useAuthYaMutation, useAuthBindVkMutation, useAuthBindYaMutation,
    /* useAuthPkceGenerateMutation,
     useLoginMutation,*/
    useInfoGetQuery } = userApi;